import { combineReducers } from "redux";
import Logic from "./LogicStore";
import AmaxApi from "./AmaxApiStore";
import SearchQuery from "./SearchQueryStore";

export default combineReducers({ AmaxApi, SearchQuery, Logic });
